/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { Image } from 'semantic-ui-react'
import { bounce, fadeIn, fadeInUp, slideInRight, pulse, rubberBand, lightSpeedIn } from 'react-animations';
// import Radium, {StyleRoot} from 'radium';
import { StyleSheet, css } from 'aphrodite';

const imageStyles = {
  borderColor: 'red',
  borderWidth: 0,
  borderStyle: 'solid',
  position: 'absolute',
  // top: 0,
  // marginLeft:
  width: '50%',
  marginLeft: '15%',

}


const styles = StyleSheet.create({
  bounce: {
    animationName: bounce,
    animationDuration: '1s'
  },
  container: {
    borderColor: 'green',
    borderWidth: 0,
    borderStyle: 'solid',
  },
  sun: {
    ...imageStyles,
    zIndex: 1,
  },
  cloud: {
    ...imageStyles,
    zIndex: 2,
  },

  leftEye: {
    ...imageStyles,
    zIndex: 3,
  },

  sunFadeIn: {
    animationDuration: '3s',
    animationName: fadeInUp,
  },

  cloudPulse: {
    // animationDuration: '3s',
    animation: 'x 7s infinite',
    animationName: pulse,

  },
})



// create image path
const imageUrl = (pngName) =>
  `/images/cloud_icon/${pngName}.png`

const Sun = (props) =>
  <div className={css([styles.sunFadeIn, styles.sun])}><Image size='big' src={imageUrl('sun')} /></div>

const Cloud = (props) =>
  <div className={css([styles.cloudPulse, styles.cloud])}><Image centered size='big' src={imageUrl('cloud')}  /></div>

const LeftEye = (props) =>
  <div className={css([styles.cloudPulse,styles.leftEye])}><Image centered size='big' src={imageUrl('eye_left')} /></div>

const RightEye = (props) =>
  <div className={css([styles.cloudPulse,styles.leftEye])}><Image centered size='big' src={imageUrl('eye_right')} /></div>

const Smile = (props) =>
  <div className={css([styles.cloudPulse,styles.leftEye])}><Image centered size='big' src={imageUrl('smile')} /></div>

const StaticCloud = (props) =>
  <div className={css([styles.cloudPulse])}><Image centered width={900} src={imageUrl('static')} /></div>

const CloudIcon = (props) => {
// large, big, huge, massive

  let CombinedImage = (
    <div className='cloud-icon'>
      <Sun />
      <Cloud />
      <LeftEye />
      <RightEye />
      <Smile />

    </div>
  )

  return CombinedImage
}

export const CloudIconStatic = (props) => {
// large, big, huge, massive

  let CombinedImage = (
    <div className='cloud-icon'>
      <StaticCloud />
    </div>
  )

  return CombinedImage
}

export default CloudIcon



// WEBPACK FOOTER //
// ./src/components/partials/CloudIcon.js